module.exports = __webpack_public_path__ + "img/norse.d05377ad.webp";